import { arrowBackOutline } from 'ionicons/icons';
import { Redirect } from 'react-router';
import { useShowInvoices } from '../../../hooks/InvoiceHooks';
import { ServicesServiceProps } from '../../../pages/ServicesPage';
import { DEFAULT_SERVICES_PATH } from '../../../services/ModelsService';
import { CloseButton } from '../../globals/CloseButton';
import { InvoiceList } from '../invoice/InvoiceList';
import { ServiceContent } from './ServiceContent';

interface ServiceModalContentProps extends ServicesServiceProps {
  backUrl: string;
}

const ServiceModalContent: React.FC<ServiceModalContentProps> = ({
  service,
  services,
  backUrl,
}) => {
  const showInvoices = useShowInvoices();

  return (
    <div className="relative md:bg-white md:rounded-3xl md:p-5">
      {service.slug === 'invoices' ? (
        showInvoices ? (
          <InvoiceList service={service} />
        ) : (
          <Redirect to={DEFAULT_SERVICES_PATH} />
        )
      ) : (
        <ServiceContent service={service} services={services} />
      )}

      <div className="modal-cross absolute top-6 left-3 md:top-5 md:left-4">
        <CloseButton to={backUrl} icon={arrowBackOutline} />
      </div>
    </div>
  );
};

export default ServiceModalContent;
